<!-- Generated by IcoMoon.io -->
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
<title></title>
<g id="icomoon-ignore">
</g>
<path class="icon-color"  fill="#fff"  d="M30.269 0l41.072 460.815 184.378 51.185 184.862-51.262 41.15-460.738h-451.462zM405.381 431.412l-148.613 41.188v0.233l-0.388-0.117-0.391 0.117v-0.233l-148.611-41.188-35.121-393.743h368.248l-35.124 393.743zM325.377 265.102l-6.535 73.276-63.105 17.035-62.931-16.958-4.025-45.117h-56.745l7.915 88.756 116.038 32.088 115.671-32.088 15.52-173.506h-205.983l-5.151-57.874h216.267l5.056-56.513h-283.109l15.249 170.901z"></path>
</svg>
